<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.373 2.89258H9.71997V21.1638H23.373V2.89258Z" fill="white"/>
    <path d="M9.19859 2.3457C8.66197 2.3457 8.22961 2.80153 8.22961 3.36889V20.6288C8.22961 21.1951 8.66197 21.652 9.19859 21.652H23.031C23.5676 21.652 24 21.1951 24 20.6288V3.36889C24 2.80153 23.5676 2.3457 23.031 2.3457H9.19859ZM9.00438 3.19348H23.217V20.7945H9.00438V3.19348Z" fill="#1F7144"/>
    <path d="M21.5098 4.88672H17.6827V7.07567H21.5098V4.88672Z" fill="#1F7144"/>
    <path d="M16.8709 4.88672H13.0438V7.07567H16.8709V4.88672Z" fill="#1F7144"/>
    <path d="M21.5098 7.87695H17.6827V10.0659H21.5098V7.87695Z" fill="#1F7144"/>
    <path d="M16.8709 7.86523H13.0438V10.0542H16.8709V7.86523Z" fill="#1F7144"/>
    <path d="M21.5098 10.9062H17.6827V13.0952H21.5098V10.9062Z" fill="#1F7144"/>
    <path d="M16.8709 10.9062H13.0438V13.0952H16.8709V10.9062Z" fill="#1F7144"/>
    <path d="M21.5098 13.9707H17.6827V16.1597H21.5098V13.9707Z" fill="#1F7144"/>
    <path d="M16.8709 13.9512H13.0438V16.1401H16.8709V13.9512Z" fill="#1F7144"/>
    <path d="M21.5098 16.9844H17.6827V19.1733H21.5098V16.9844Z" fill="#1F7144"/>
    <path d="M16.8709 16.9844H13.0438V19.1733H16.8709V16.9844Z" fill="#1F7144"/>
    <path d="M13.6535 24V0L0 2.39935V21.5996L13.6535 24Z" fill="url(#paint0_linear_7718_3582)"/>
    <path d="M5.3428 7.98948L6.28826 10.5924C6.35643 10.7461 6.38711 10.9112 6.4028 11.0222C6.39553 10.8928 6.42125 10.7918 6.49064 10.5924L7.61089 7.84656L9.33215 7.73828C8.63516 9.14446 7.96485 10.5653 7.32163 11.9999L9.41801 16.384L7.56285 16.267L6.43545 13.4064C6.34727 13.1907 6.36429 13.1613 6.34652 13.0556C6.33832 13.1308 6.33548 13.1925 6.28826 13.3285L5.1537 16.1154L3.56226 16.0147L5.40208 12.0584L3.74624 8.09017L5.3428 7.98948Z" fill="white"/>
    <defs>
      <linearGradient id="paint0_linear_7718_3582" x1="13.6533" y1="12.0001" x2="0.000380849" y2="12.0001" gradientUnits="userSpaceOnUse">
        <stop stop-color="#1D6B40"/>
        <stop offset="1" stop-color="#217748"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#000000',
    },
  },
};
</script>
